import { render, staticRenderFns } from "./ModalComponent.vue?vue&type=template&id=68faf5be"
import script from "./ModalComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports